<div>
  <h2>{{ data.header || 'MORE INFO'}}</h2>
  <p>{{ data.body || 'To see if a payment has been made, and to find out what options you may have available, or any action you may need to take, call 1-888-510-1084 Monday through Friday, 8:00 a.m. - 8:00 p.m. (TTY/TDD: 800-696-4710)'}}</p>
  <button mat-raised-button class="primary" (click)="closeModal()">Ok</button>
</div>
